<div class="container">
    <h1 class="page-title"
      [helpCenterButton]="helpPermissionCode" [lang]="currentLang"
      [helpCenterDownloadButton]="helpPermissionCode" [position]="'inline'" [lang]="currentLang"><span class="icon"><i class="fas fa-users-gear"></i></span>{{ 'UserMaintenance.Header' | translate }}</h1>
    <p-card>
        <p-accordion>
            <p-accordionTab header="{{ 'Common.Form.Header' | translate }}" [selected]="isSearchFormOpen">
                <form>
                    <div class="p-fluid formgrid grid">
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'UserMaintenance.Search.Account' | translate }}</label>
                            <input pInputText type="text" [(ngModel)]="account" [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'UserMaintenance.Search.Name' | translate }}</label>
                            <input pInputText type="text" [(ngModel)]="userName" [ngModelOptions]="{standalone: true}" />
                        </div>
                        <div class="col-12 md:col-6 lg:col-4 mb-3">
                            <label>{{ 'UserMaintenance.Search.Email' | translate }}</label>
                            <input pInputText type="text" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" />
                        </div>
                    </div>
                    <div class="grid">
                        <div class="col">
                            <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick($event)"></button>
                            <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtnClick($event)" class="p-button-secondary ml-2"></button>
                            <button pButton pRipple label="{{ 'UserMaintenance.Button' | translate }}" (click)="addMember($event)" class="p-button-info ml-2"></button>
                        </div>
                    </div>
                </form>
            </p-accordionTab>
        </p-accordion>
        <div class="mt-2">
            <p-table #DODataTable [value]="userResults" [resizableColumns]="true" [reorderableColumns]="true" [rowHover]="true" [loading]="isLoading" columnResizeMode="expand" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10, 25, 50]" [rows]="5" [rowsPerPageOptions]="[5, 10, 25, 50]"
                [autoLayout]="true" sortMode="multiple" class="datatable" styleClass="p-datatable-striped">
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <th>{{ 'UserMaintenance.MainTable.Account' | translate }}</th>
                        <th>{{ 'UserMaintenance.MainTable.UserType' | translate }}</th>
                        <th>{{ 'UserMaintenance.MainTable.UserName' | translate }}</th>
                        <th>{{ 'UserMaintenance.MainTable.Email' | translate }}</th>
                        <!-- <th>Status</th> -->
                        <th>{{ 'UserMaintenance.MainTable.IsActivated' | translate }}</th>
                        <th>{{ 'UserMaintenance.MainTable.Action' | translate }}</th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData>
                    <tr>
                        <td>{{rowData.loginAccount}}</td>
                        <td>{{rowData.userType}}</td>
                        <td>{{rowData.userName}}</td>
                        <td>{{rowData.email}}</td>
                        <td>{{rowData.isActivated | activated}}</td>
                        <!-- <td>{{rowData.status | userStatus}}</td> -->
                        <td>
                            <i class="pi pi-pencil" (click)="gotoModify($event, rowData)"></i>
                            <i class="pi pi-book ml-2" (click)="previewUser($event, rowData)"></i>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td [attr.colspan]="6" style="text-align: center;">
                            {{ 'Common.Table.NoData' | translate }}
                        </td>
                    </tr>
                </ng-template>
            </p-table>
        </div>
    </p-card>
</div>
<help-dock
  [permissionCode]="helpPermissionCode"
  [lang]="currentLang">
</help-dock>
